/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { sendHandoverConfirmationEmail } from '../fn/emails/send-handover-confirmation-email';
import { SendHandoverConfirmationEmail$Params } from '../fn/emails/send-handover-confirmation-email';

@Injectable({ providedIn: 'root' })
export class EmailsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `sendHandoverConfirmationEmail()` */
  static readonly SendHandoverConfirmationEmailPath = '/api/v1/emails/case/{id}/cargo_handover_confirmation';

  /**
   * Send email with about deceased cargo handover confirmation using information from the case by case id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendHandoverConfirmationEmail()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendHandoverConfirmationEmail$Response(params: SendHandoverConfirmationEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return sendHandoverConfirmationEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * Send email with about deceased cargo handover confirmation using information from the case by case id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendHandoverConfirmationEmail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendHandoverConfirmationEmail(params: SendHandoverConfirmationEmail$Params, context?: HttpContext): Observable<void> {
    return this.sendHandoverConfirmationEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
